import DocIcon from './assets/doc-file.svg?react';
import CsvIcon from './assets/csv-file.svg?react';
import ImgIcon from './assets/img-file.svg?react';
import PDFIcon from './assets/pdf.svg?react';
import PptIcon from './assets/ppt-file.svg?react';
import TextIcon from './assets/text-file.svg?react';

const PPT_MIME_TYPES = new Set([
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint',
  'application/vnd.apple.keynote',
]);

const EXCEL_MIME_TYPES = new Set([
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
]);

const CSV_MIME_TYPES = new Set(['text/csv', 'text/tab-separated-values', 'text/x-iif']);

const DOC_MIME_TYPES = new Set([
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'application/vnd.oasis.opendocument.text',
  'application/rtf',
  'application/vnd.apple.pages',
]);

export function getFileIcon(mimeType: string) {
  if (mimeType.startsWith('image/')) {
    return <ImgIcon />;
  }
  if (mimeType === 'application/pdf') {
    return <PDFIcon />;
  }
  if (PPT_MIME_TYPES.has(mimeType)) {
    return <PptIcon />;
  }
  if (EXCEL_MIME_TYPES.has(mimeType)) {
    return <CsvIcon />;
  }
  if (CSV_MIME_TYPES.has(mimeType)) {
    return <CsvIcon />;
  }
  if (DOC_MIME_TYPES.has(mimeType)) {
    return <DocIcon />;
  }
  return <TextIcon />;
}
